import { Snackbar } from '@mui/material';
import { Alert } from '@mui/material';
import React from "react";


const AlertSakeBar = ({
  open = false,
  message = "",
  severity = "info",
  duration = 3000,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={duration}
      onClose={onClose}
    >
      <Alert  onClose={onClose} severity={severity}>
        <strong>ALERT:</strong> {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertSakeBar;
